const configuredAdminEmails = () =>
    (process.env.REACT_APP_ADMIN_EMAILS || '')
        .split(',')
        .flatMap((email) => {
            const normalizedEmail = email.trim().toLowerCase();
            return normalizedEmail ? [normalizedEmail] : [];
        });

export const isAdminUser = (user) => {
    const email = String(user?.email || '').trim().toLowerCase();
    return Boolean(email && configuredAdminEmails().includes(email));
};
